import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'
import axios from 'axios'

Vue.use(Vuex);

var axios_instance = axios.create({});

var localhost = false;

const api_endpoint='https://qds-api.aashay.cf';
var apiv1_endpoint = 'https://api.qdspro.com/v1';

if(localhost) apiv1_endpoint = 'http://localhost:3000/v1'

export const store = new Vuex.Store({
	state: {
		user: {
			id:'',
			full_name:'',
			date_of_birth:'',
			gender:'',
			address:'',
			college:'',
			is_currently_working:'',
			organization:'',
			entrance_exam:'',
			contactable_by_admin:'',
			receive_notifications:'',
			email:'',
			is_logged_in: false,
			credits: {
				credit:0,
				debit:0
			},
			blocked:"no",
			user_type:'',
			signup_datetime:'',
			doubts:[],
			packages:[],
			chat_restore_id:'',
			referral_code:'',
			transactions:[],
			is_referral_code_used:''
		},
		global_loader: false,
		packages:[],
		study_material_list:[],
	},
	getters: {
		user: state => {
			return state.user;
		},
		global_loader: state => {
			return state.global_loader;
		},
		get_packages: state => {
			return state.packages;
		},
		get_user_packages: state => {
			return state.user.packages;
		},
		get_study_material_list: state => {
			return state.study_material_list;
		}
	},
	mutations: {
		setToken(state,token) {
			localStorage.setItem('token',token);
			axios_instance.defaults.headers.common['Authorization']='Bearer '+token;
			return true;
		},

		removeToken(state) {
			localStorage.removeItem('token');
		},

		setUser(state, user) {
			for(var property in state.user) {
				
				if(user.hasOwnProperty(property)) {
					state.user[property] = user[property]
				}
			}
		},
		setPackages(state, data) {
			state.packages = data;
		},
		setUserPackages(state, data) {
			state.user.packages = data;
		},
		setLoader(state,loading) {
			state.global_loader = loading;

			if(loading) {
				store.commit('disableBodyOverflow');
			} else {
				store.commit('enableBodyOverflow');
			}
		},
		disableBodyOverflow(state) {
			document.body.classList.add('no-overflow');
		},
		enableBodyOverflow(state) {
			document.body.classList.remove('no-overflow');
		},
		setStudyMaterialList(state, data) {
			state.study_material_list = data;
		},
		setUserTransactions(state, data) {
			state.user.transactions = data;
		}
	},
	actions: {
		async signup(context,data) {
			
			try {
				
				const result2 = await axios_instance.post(apiv1_endpoint+'/users',data);

				console.log(result2);

				return result2;

				//console.log(result);


			} catch(ex) {
				throw Error('You have entered incorrect OTP!')
			}
		},

		async login(context, data) {
			//required data params
			// email, password.

			console.log('trying to login');

			try {
				
				const result2 = await axios_instance.post(apiv1_endpoint+'/get-token',{
					user_id: data.email,
					password: data.password,
				});

				console.log(result2);

				//console.log(result);

				context.commit('setToken',result2.data.token);

				let user = {
					is_logged_in: true
				}
				context.commit('setUser',user);

				return {
					status:'success'
				};

			} catch(ex) {
				console.log('got error',ex);
				return {
					status:'failure', 
					error:'You have entered incorrect credentials!'
				}
			}
		},
		async logout(context) {
			await context.commit('removeToken');
			context.commit('setUser',{is_logged_in:false});
		},
		async send_otp(context,data) {
			try {
				
				const result2 = await axios_instance.post(apiv1_endpoint+'/send-otp',{
					email: data.email,
					captcha: data.captcha
				});

				return result2;

			} catch(ex) {
				throw Error('Otp sending failed, please try again!')
			
			}
		},
		async fetch_me(context) {
			try {
				
				const result2 = await axios_instance.get(apiv1_endpoint+'/me');

				context.commit('setUser',result2.data[0]);

			} catch(ex) {
				console.log(ex.toString());
				throw Error('Could not fetch user info')
			
			}
		},
		async fetch_user_transactions(context) {
			try {
				const result = await axios_instance.get(apiv1_endpoint+'/me/transactions');

				context.commit('setUserTransactions', result.data.data);

			} catch(ex) {
				return false;
			}
		},
		async fetch_packages(context) {
			try {
				
				const result2 = await axios_instance.get(apiv1_endpoint+'/packages');
				console.log('store',result2);
				context.commit('setPackages',result2.data.data);

			} catch(ex) {
				console.log(ex.toString());
				throw Error('Could not fetch the packages!')
			
			}
		},
		async capture_payment(context,data) {
			try {
				
				const result2 = await axios_instance.post(apiv1_endpoint+'/capture-payment',data);
				console.log('store',result2);
				return result2;

			} catch(ex) {
				console.log(ex.toString());
				throw Error('Could not process your payment!')
			
			}
		},
		async send_password_reset_email(context,email) {
			try {
				
				const result2 = await axios_instance.post(apiv1_endpoint+'/send-password-reset-email',{email:email});
				
				return {
					status:"success"
				}

			} catch(ex) {
				
				return {
					status: "failure"
				}
			
			}
		},
		async fetch_doubts(context) {
			try {
				
				const result2 = await axios_instance.get(apiv1_endpoint+'/doubts');
				
				context.commit('setUser',{doubts:result2.data.data});

			} catch(ex) {
				console.log(ex.toString());
				throw Error('Could not fetch the packages!')
			
			}
		},
		async add_doubt(context,data) {
			try {
				console.log('at store',data);
				const result2 = await axios_instance.post(apiv1_endpoint+'/doubts',data);

				const fetch_doubts = await context.dispatch('fetch_doubts');

				const fetch_me = context.dispatch('fetch_me');
				
				return result2;

			} catch(ex) {
				console.log(ex.toString());
				throw Error('Could not add Doubt, please try again!');
			
			}
		},
		async fetch_doubt_attachment(context, doubt_id) {
			try {
				
				const result = await axios_instance.get(apiv1_endpoint+'/doubts/'+doubt_id+'/attachment');
				
				return result;

			} catch(ex) {
				console.log(ex.toString());
				throw Error('Could not fetch the attachment for doubt!');
			
			}
		},
		async fetch_doubt_solution(context, doubt_id) {
			try {
				
				const result = await axios_instance.get(apiv1_endpoint+'/doubts/'+doubt_id+'/solution');
				
				return result;

			} catch(ex) {
				console.log(ex.toString());
				throw Error('Could not fetch the solution for doubt!');
			
			}
		},
		async fetch_doubt_solution_attachment(context, doubt_id) {
			try {
				
				const result = await axios_instance.get(apiv1_endpoint+'/doubts/'+doubt_id+'/solution/attachment');
				
				return result;

			} catch(ex) {
				console.log(ex.toString());
				throw Error('Could not fetch the solution attachment!');
			
			}
		},
		async fetch_user_packages(context) {
			try {
				const result = await axios_instance.get(apiv1_endpoint+'/me/packages');

				context.commit('setUserPackages',result.data.data);
			} catch(ex) {
				throw Error('Could not fetch your package history!');
			}
		},
		async fetch_study_material_list(context) {
			try {
				const result = await axios_instance.get(apiv1_endpoint+'/study-material');

				context.commit('setStudyMaterialList',result.data.data);
			} catch(ex) {
				throw Error('Could not fetch study material');
			}
		},
		async fetch_study_material_content(context, id) {
			try {
				const result = await axios_instance.get(apiv1_endpoint+'/study-material/'+id);

				return result.data.data;
			} catch(ex) {
				throw Error('Could not fetch study material');
			}
		},
		async save_doubt_note(context, data) {
			try {
				
				const result = await axios_instance.put(apiv1_endpoint+'/doubts/'+data.doubt_id+'/note', data);
				
				return result;

			} catch(ex) {
				console.log(ex.toString());
				throw Error('Could not fetch the attachment for doubt!');
			
			}
		},
		async set_chat_restore_id(context, restore_id) {
			try {
				console.log('saving', restore_id);
				const result = await axios_instance.post(apiv1_endpoint+'/me/set_chat_restore_id', {restore_id:restore_id});
				return result;

			} catch(ex) {
				console.log(ex.toString());
				throw Error('Could not save chat restore id');
			}
		},
		async save_profile(context,data) {
			try {
	
				const result = await axios_instance.put(apiv1_endpoint+'/users',data);
				return result;
			} catch(ex) {
				console.log(ex.toString());
				throw Error('Could not save profile');
			}
		},
		async save_password(context,data) {
			try {
				const result = await axios_instance.post(apiv1_endpoint+'/update_password',data);
				return result;
			} catch(ex) {
				console.log(ex.toString());
				throw Error('Could not save password');
			}
		},
		async save_counselling_form(context,data) {
			try {
	
				const result = await axios_instance.put(apiv1_endpoint+'/users/career-counselling',data);
				return result;
			} catch(ex) {
				console.log(ex.toString());
				throw Error('Could not save counselling form');
			}
		},
		async get_counselling_form(context) {
			try {
	
				const result = await axios_instance.get(apiv1_endpoint+'/me/career-counselling');
				return result.data;
			} catch(ex) {
				console.log(ex.toString());
				throw Error('Could not get counselling form');
			}
		},
		async verify_referral_code(context, code) {
			try {
				const result = await axios_instance.post(apiv1_endpoint+'/verify-referral-code', {referral_code:code});
				return result.data;
			} catch(ex) {
				return false;
			}
		},
		async apply_referral_code(context, code) {
			try {
				const result = await axios_instance.post(apiv1_endpoint+'/apply-referral-code', {referral_code:code});
				return true;
			} catch(ex) {
				return false;
			}
		},

		async rate_solution(context, data) {
			try {
				const result = await axios_instance.put(apiv1_endpoint+'/doubts/'+data.doubt_id+'/solution/rating', data);
				return result.data;

			} catch(ex) {
				return false;
			}
		}
	}
})


// WEBPACK FOOTER //
// ./src/store/index.js